import * as Sentry from '@sentry/react';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import { selectMSTeamsContext } from 'selectors/msTeamsSelector';
import store from 'store.js';

import { localStorageKeys } from './localStorageKeys';
import { getUsefulTrackingDataFromLoggedInEmployee, sendMixpanelData } from './mixpanel';
import {
  ALL_TRACKING_EVENTS,
  ENGAGEMENT_EVENTS,
  GENERIC_EVENTS,
  GOAL_EVENTS,
  HOME_EVENTS,
  CONTINUOUS_FEEDBACK_EVENTS,
  INSIGHT_EVENTS,
  REVIEW_EVENTS,
  INITIATIVE_EVENTS,
  ONE_ON_ONE_EVENTS,
  SETTINGS_EVENTS,
  LEVELUP_EVENTS,
  MESH_RECOMMENDATIONS_EVENTS,
  ONE_ON_ONE_RABBIT_SETTINGS_PAGE,
  VISIER_ANALYTICS_EVENTS,
  NEW_NAV_EVENTS,
} from './trackingEvents';

const sendSentryError = ({ err, name }) => {
  const err1 = err;
  err1.name = name;
  Sentry.withScope((scope) => {
    scope.setTag('severity', 2);
    scope.setLevel('error');
    Sentry.captureException(err1);
  });
};

function getSuperProperties() {
  const loggedInEmployeeData = selectLoggedInEmployeeData(store.getState());
  const demoUserEmailLS = window.localStorage.getItem(localStorageKeys.demoUserEmail);
  const isMsTeamsVisitor = selectMSTeamsContext(store.getState());
  const {
    organizationId,
    organizationName,
    organizationStatus: organizationType,
    planType: organizationPlan,
    country: organizationEntity,
  } = getUsefulTrackingDataFromLoggedInEmployee(loggedInEmployeeData);
  const sender = isMsTeamsVisitor ? 'msteams' : 'frontend';
  // TODO: mixpanel . some way to identify platform webapp/chrome/teamsapp extension etc.
  const platform = 'webapp';

  const superProps = {
    organizationId,
    organizationName,
    organizationType,
    organizationPlan,
    organizationEntity,
    platform,
    sender,
    // todo: remove
    isRabbitUI: true,
  };

  if (demoUserEmailLS) {
    superProps.demoUserEmail = JSON.parse(demoUserEmailLS);
  }

  return superProps;
}
// ---------------------------------------------to be deleted after replacing usage
export const TASK_EVENTS = {
  addedNew: 'AddedNew', // P0 not working.
  markedComplete: 'MarkedAsComplete', // not used, depreciated.
  openedTaskPanel: 'OpenedTaskPanel', // P0 used at too many places. need to spend more time on this
  openedSidePanel: 'OpenedSidePanel',
  hashtagCreated: 'HashtagCreated',
  changedTeam: 'ChangedTeam', // P1
  updated: 'Updated', // P0
  reassigned: 'Reassigned',
  // new events
  status: 'Status', // P0
  commented: 'Commented', // P0
  createdSubTask: 'CreatedSubTask',
  completedSubTask: 'CompletedSubTask',
  addedSubTask: 'addedSubTask',
  applaused: 'applaused',
  AddedNewTask: 'AddedNewTask',
};

export const GOAL_EVENTS1 = {
  ...TASK_EVENTS,
  goalDeleted: 'GoalDeleted',
  UpdatedProgressBar: 'UpdatedProgressBar',
  UpdatedEndDate: 'UpdatedEndDate',
  UpdatedOwnerField: 'UpdatedOwnerField',
  UpdatedCollaboratorsField: 'UpdatedCollaboratorsField',
  UpdatedStartDate: 'UpdatedStartDate',
  UpdatedObjective: 'UpdatedObjective',
};

export const ONE_ON_ONE_EVENTS_OLD = {
  openedSidePanel: 'OpenedSidePanel', // depreciated
  startedOneOnOne: 'Started',
  completedOneOnOne: 'Completed',
  acknowledgedOneOnOne: 'Acknowledged',
  addedActionItem: 'AddedActionItem',
  navigateToInstancePage: 'NavigateToInstancePage',
  createdNewOneOnOne: 'createdNew1:1',
  completedAgenda: 'completedAgenda',
  completedActionItem: 'completedActionItem',
  updateAgendaItem: 'updateAgendaItem',
  upateActionItem: 'upatedActionItem',
  answeredTalkingPoints: 'answeredTalkingPoints1:1',
  answeredEmojiTypeTalkingPoint: 'answeredEmojiTalkingPoints1:1',
  answeredTextTypeTalkingPoint: 'answeredTextTypeTalkingPoint1:1',
  updatedTalkingPoint: 'updatedTalkingPoint1:1',
  createdNewTemplate: 'createdNewTemplate1:1',
  updatedTemplate: 'updatedTemplate1:1',
  archivedTemplate: '',
  unarchivedTemplate: '',
  editedTemplate: 'editedTemplate1:1',
  createdNewQuestion: 'createdNewQuestion1:1',
  updatedQuestion: 'updatedQuestion1:1',
  addedSubTask: 'addedSubTask1:1',
  applaused: 'applaused1:1',
  changeDetails: 'detailsChanged1:1',
  commentedOnTask: 'commented1:1',
  completedSubTask: 'completedSubTask1:1',
};

// export const CONTINUOUS_FEEDBACK_EVENTS = {
//   openedRequestMoreSidePanel: 'OpenedRequestMoreSidePanel',
//   openedShareMoreSidePanel: 'OpenedShareMoreSidePanel',
//   requestedFeedback: 'RequestedFeedback',
//   filledFeedback: 'FilledFeedback',
//   archivedFeedback: 'ArchivedFeedback',
//   sharedFeedback: 'SharedFeedback',
//   viewRequestedFeedback: 'ViewedFeedback',
//   viewedFeedbackList: 'ViewedFeedbackList'
// };

export const GOAL_ANALYTICS_EVENTS = {
  changedCohort: 'ChangedCohort',
  changedSource: 'ChangedSource',
  changedGroupBy: 'ChangedGroupBy',
  openedExpandedView: 'OpenedExpandedView',
  expandedObjective: 'ExpandedObjective',
  openedGoalSidePanel: GOAL_EVENTS1.openedSidePanel,
};

export const EMAIL_CAPTURE_EVENTS = {
  pausedVideo: 'PauseVideo',
  submitted: 'Submitted',
};

export const EMAIL_VALIDATION_EVENTS = {
  validated: 'Validated',
};
export const DEPT_SELECTION_EVENTS = {
  submitted: 'Submitted',
};
export const TEAM_SELECTION_EVENTS = {
  submitted: 'Submitted',
};
export const TEAM_INVITE_EVENTS = {
  submitted: 'Submitted',
  skipped: 'Skipped',
};
export const POST_EVENTS = {
  openedCreatePostModal: 'OpenedCreatePostModal',
  createdNew: 'CreatedNew',
  updated: 'Updated',
  applauded: 'Applauded',
  commented: 'Commented',
  liked: 'Liked',
  openedTaskPanel: 'OpenedTaskPanel',
};
export const SEARCH_EVENTS = {
  navigatedToTeamPage: 'NavigatedToTeamPage',
  navigatedToProfilePage: 'NavigatedToProfilePage',
  navigatedToTagPage: 'NavigatedToTagPage',
};
export const TEAM_HUB_EVENTS = {
  toggledTaskType: 'ToggledTaskType',
  toggledViewType: 'ToggledViewType',
};

export const REVIEW_EVENTS1 = {
  openedNominateSidePanel: 'openedNominateSidePanel',
  nominated: 'Nominated',
  reviewSubmitted: 'ReviewSubmitted',
};
export const NOTIFICATION_EVENTS = {
  openedTask: 'OpenedTask',
  navigatedToPage: 'NavigatedToPage',
  loadedMore: 'LoadedMore',
};

//---------------------------------------------------

export function sendEvent({ eventName, source = null, eventProperties = {} }) {
  try {
    if (process.env.PUBLIC_APP_ENABLE_TRACKING !== 'true') return;
    if (!process.env.PUBLIC_APP_MIXPANEL_KEY) return;

    // the eventName must be defined in appropriate enum constants
    if (Object.values(ALL_TRACKING_EVENTS).indexOf(eventName) === -1) {
      const errorMessage = `Tracking event call aborted!! The supplied tracking eventName: "${eventName}" does not exist in ALL_TRACKING_EVENTS enum. Please include it there to send the tracking event. `;
      // console.error(errorMessage);
      sendSentryError({
        err: new Error(errorMessage),
        name: `[SEV2]: Non defined tracking event`,
      });
      return;
    }

    // conditionally add 'source' to event properties if applicable.
    // const source = getEventSource(source);

    // todo: mixpanel get and add all super properties to event properties
    const superProperties = getSuperProperties();
    let finalEventProperties = { ...eventProperties, ...superProperties };
    if (source) {
      finalEventProperties = { ...finalEventProperties, source };
    }

    sendMixpanelData(eventName, finalEventProperties);
  } catch (err) {
    sendSentryError({
      err,
      name: `[SEV2]: Event tracking call to mixpanel failed`,
    });
  }
}

function sendEvent2() {
  return () => {};
}

// ----------------------------- new events

// Generic Events

export const sendErrorBoundaryCrashEvent = ({ eventName = GENERIC_EVENTS.SEV_1_ERROR, eventProperties }) =>
  sendEvent({
    eventName,
    eventProperties,
  });

export const sendPageViewEvent = ({ eventName = GENERIC_EVENTS.PAGE_VIEW, eventProperties = {} }) => {
  sendEvent({ eventName, eventProperties });
};

export const sendHelpCenterClickedEvent = ({
  eventName = GENERIC_EVENTS.HELP_CENTER_CLICKED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotificationPanelOpenedEvent = ({
  eventName = GENERIC_EVENTS.NOTIFICATION_PANEL_OPENED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotificationClickedEvent = ({
  eventName = GENERIC_EVENTS.NOTIFICATION_CLICKED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSearchEvent = ({ eventName = GENERIC_EVENTS.SEARCH, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendLoginEvent = ({ eventName = GENERIC_EVENTS.LOGIN, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendLogoutEvent = ({ eventName = GENERIC_EVENTS.LOGOUT, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sentClickedOnMoreViewsEvent = ({
  eventName = GENERIC_EVENTS.CLICKED_ON_MORE_VIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnHelpMeWriteEvent = ({
  eventName = GENERIC_EVENTS.CLICKED_ON_HELP_ME_WRITE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUsedMeshMavenGeneratedContentEvent = ({
  eventName = GENERIC_EVENTS.USED_MESH_MAVEN_GENERATED_CONTENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRephrasedMeshMavenContentEvent = ({
  eventName = GENERIC_EVENTS.REPHRASED_MESH_MAVEN_CONTENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReanalyzedMeshMavenContentEvent = ({
  eventName = GENERIC_EVENTS.REANALYZED_MESH_MAVEN_CONTENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReanalyzedMeshMavenResultsForGoals = ({
  eventName = GENERIC_EVENTS.REANALYZED_MESH_MAVEN_RESULTS_FOR_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendGeneratedMeshMavenPersonalizedGoalResults = ({
  eventName = GENERIC_EVENTS.GENERATED_MESH_MAVEN_PERSONALIZED_GOAL_RESULTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// Home page events

export const sendClickedOnPraiseEvent = ({ eventName = HOME_EVENTS.CLICKED_ON_PRAISE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAdviceEvent = ({ eventName = HOME_EVENTS.CLICKED_ON_ADVISE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewTabsOfHomepageEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.VIEWED_TABS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCreatedNewFromTabsOfHomepageEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.CREATED_NEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// currently filtering is there only for initiatives
export const sendFilteredTabsOfHomepageEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.FILTERED_TABS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRefreshedTabsOfHomepageEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.REFRESHED_TABS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendQuicklyCreatedInitiativeEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.QUICK_CREATE_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendOpenedOneOnOneSidePanelEvent = ({
  eventName = HOME_EVENTS.MESH_LIST.OPENED_ONE_ON_ONE_SIDEPANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUpdateProfileImageEvent = ({
  eventName = HOME_EVENTS.UPDATE_PROFILE_IMAGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedViewTeamMembersEvent = ({
  eventName = HOME_EVENTS.CLICKED_VIEW_TEAM_MEMBERS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedViewProfileEvent = ({
  eventName = HOME_EVENTS.CLICKED_VIEW_PROFILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUploadPostImageEvent = ({ eventName = HOME_EVENTS.UPLOAD_IMAGE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendPostedMessageEvent = ({ eventName = HOME_EVENTS.POSTED_MESSAGE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedPostEvent = ({ eventName = HOME_EVENTS.CLICKED_POST, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendTopNavNavigationEvents = ({ eventName, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLikedPostEvent = ({ eventName = HOME_EVENTS.LIKED_POST, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendScrolledFeedEvent = ({ eventName = HOME_EVENTS.SCROLLED_FEED, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNudgeCardEvent = ({
  eventName = HOME_EVENTS.CLICKED_NUDGE_CARD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnMySummaryFilterEvent = ({
  eventName = HOME_EVENTS.CLICKED_ON_MY_SUMMARY_FILTERS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnQuickActionsEvent = ({
  eventName = HOME_EVENTS.CLICKED_ON_QUICK_ACTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const viewedMySummaryEvent = ({ eventName = HOME_EVENTS.VIEWED_MY_SUMMARY, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const viewedMyFeedEvent = ({ eventName = HOME_EVENTS.VIEWED_MY_FEEDBACK, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

// Continous Feedback Events

export const sendSharedFeedback = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.SHARED_FEEDBACK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRequestedFeedback = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.REQUESTED_FEEDBACK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewedShared = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.VIEWED_SHARED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRespondedToFeedbackRequest = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.RESPONDED_TO_FEEDBACK_REQUEST,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendResponseOfFeedbackRequest = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.RESPONSE_OF_FEEDBACK_REQUEST,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEditedFeedback = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.EDITED_FEEDBACK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewedFeedbackList = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.VIEWED_FEEDBACK_LIST,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedSharedFeedbackEvent = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.OPENED_SHARED_FEEDBACK_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedRequestFeedbackEvent = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.OPENED_REQUEST_FEEDBACK_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedPendingFeedbackEvent = ({
  eventName = CONTINUOUS_FEEDBACK_EVENTS.OPENED_PENDING_FEEDBACK_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// Initiatives Events

export const sendCreatedInitiative = ({
  eventName = INITIATIVE_EVENTS.CREATED_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCommentedOnInitiative = ({
  eventName = INITIATIVE_EVENTS.COMMENTED_ON_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUpdatedInitiative = ({
  eventName = INITIATIVE_EVENTS.UPDATED_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRealignedInitiative = ({
  eventName = INITIATIVE_EVENTS.REALIGNED_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRealignedParentOfInitiative = ({
  eventName = INITIATIVE_EVENTS.REALIGNED_PARENT_OF_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedInitiativePanel = ({
  eventName = INITIATIVE_EVENTS.OPENED_INITIATIVE_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSharedInitiative = ({
  eventName = INITIATIVE_EVENTS.SHARED_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLandingPageOfInitiatives = ({
  eventName = INITIATIVE_EVENTS.LANDING_PAGE_OF_INITIATIVES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendFiltersOfInitiatives = ({
  eventName = INITIATIVE_EVENTS.FILTERS_OF_INITIATIVES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnTimePeriodOfInitiatives = ({
  eventName = INITIATIVE_EVENTS.CLICKED_ON_TIME_PERIOD_OF_INITIATIVES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangeViewType = ({ eventName = INITIATIVE_EVENTS.CHANGED_VIEW_TYPE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSortedInitiatives = ({
  eventName = INITIATIVE_EVENTS.SORTED_INITIATIVES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// 1:1 Events

export const sendOpensOneononeTab = ({
  eventName = ONE_ON_ONE_EVENTS.OPENS_ONEONONE_TAB,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCreatedOneonone = ({ eventName = ONE_ON_ONE_EVENTS.CREATED_ONEONONE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedOneononeDetail = ({
  eventName = ONE_ON_ONE_EVENTS.OPENED_ONEONONE_DETAIL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedCalendarNotification = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_CALENDAR_NOTIFICATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedOneononePreference = ({
  eventName = ONE_ON_ONE_EVENTS.OPENED_ONEONONE_PREFERENCE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnMoodQuestion = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_MOOD_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRespondedToMoodQuestion = ({
  eventName = ONE_ON_ONE_EVENTS.RESPONDED_TO_MOOD_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedToOneononeAgenda = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_TO_ONEONONE_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedOneononeAgenda = ({
  eventName = ONE_ON_ONE_EVENTS.COMPLETED_ONEONONE_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedCommentsToOneononeQuestions = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_COMMENTS_TO_ONEONONE_QUESTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedActionItemsToOneonone = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_ACTION_ITEMS_TO_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedActionItems = ({
  eventName = ONE_ON_ONE_EVENTS.COMPLETED_ACTION_ITEMS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedActionItemOwner = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_ACTION_ITEM_OWNER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedActionItemDate = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_ACTION_ITEM_DATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRescheduledOneonone = ({
  eventName = ONE_ON_ONE_EVENTS.RESCHEDULED_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedOneonone = ({
  eventName = ONE_ON_ONE_EVENTS.COMPLETED_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendArchivedOneonone = ({
  eventName = ONE_ON_ONE_EVENTS.ARCHIVED_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUnarchivedOneonone = ({
  eventName = ONE_ON_ONE_EVENTS.UNARCHIVED_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnMeshRecommends = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_MESH_RECOMMENDS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// 1:1 refreshed Events

export const sendStartsOneOnOneEvent = ({
  eventName = ONE_ON_ONE_EVENTS.STARTS_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendContinuesOneOnOneEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CONTINUES_ONEONONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendViewsOneOnOneEvent = ({ eventName = ONE_ON_ONE_EVENTS.VIEWS_ONEONONE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnEndMeetingEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_END_MEETING,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnReopenEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_REOPEN,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnRescheduleEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_RESCHEDULE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedOnCancelEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_CANCEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// 1:1 instance page

export const sendClickedOnModuleDataEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_MODULE_DATA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAddCustomAgendaEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_ADD_CUSTOM_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAddAdminAgendaEvent = ({
  eventName = ONE_ON_ONE_EVENTS.ADD_ONE_ON_ONE_ADMIN_AGENDA_POINTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAddInitiativeEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_ADD_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAgendaItemsReorderedEvent = ({
  eventName = ONE_ON_ONE_EVENTS.AGENDA_ITEMS_REORDERED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedAgendaItemNotesEvent = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_AGENDA_ITEM_NOTES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnDeleteAgendaEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_DELETE_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedAgendaEvent = ({
  eventName = ONE_ON_ONE_EVENTS.COMPLETED_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedOneOnOneInitiativeEvent = ({
  eventName = ONE_ON_ONE_EVENTS.COMPLETED_ONE_ON_ONE_INITIATIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedOneOnOneNotesEvent = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_ONE_ON_ONE_NOTES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnEditOneOnOneEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_EDIT_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCancelledOneOnOneInstanceEvent = ({
  eventName = ONE_ON_ONE_EVENTS.CANCELLED_ONE_ON_ONE_INSTANCE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendArchivedOneOnOneInstanceEvent = ({
  eventName = ONE_ON_ONE_EVENTS.ARCHIVED_ONE_ON_ONE_INSTANCE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// goals events

export const sendCreatedKREvent = ({ eventName = GOAL_EVENTS.CREATED_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnCreateKRevent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_CREATE_KR,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSortedGoalsEvent = ({ eventName = GOAL_EVENTS.SORTED_GOALS, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewTypeChangedEvent = ({ eventName = GOAL_EVENTS.CHANGED_VIEW_TYPE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnTimePeriodEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_TIMEPERIOD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAppliedFilterEvent = ({ eventName = GOAL_EVENTS.APPLIED_FILTER, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendShareKREvent = ({ eventName = GOAL_EVENTS.SHARED_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendShareObjectiveEvent = ({ eventName = GOAL_EVENTS.SHARED_OBJECTIVE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedObjectivePanelEvent = ({
  eventName = GOAL_EVENTS.OPENED_OBJECTIVE_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUpdatedObjectiveEvent = ({ eventName = GOAL_EVENTS.UPDATED_OBJECTIVE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendUpdatedKREvent = ({ eventName = GOAL_EVENTS.UPDATED_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCommentedOnKREvent = ({ eventName = GOAL_EVENTS.COMMENTED_ON_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRealignedKREvent = ({ eventName = GOAL_EVENTS.REALIGNED_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedRealignedEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_REALIGNED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRealignedObjectiveEvent = ({
  eventName = GOAL_EVENTS.REALIGNED_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedKRPanelEvent = ({ eventName = GOAL_EVENTS.OPENED_KR_PANEL, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCreatedObjectiveEvent = ({ eventName = GOAL_EVENTS.CREATED_OBJECTIVE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendDownloadCSVGoalsEvent = ({ eventName = GOAL_EVENTS.DOWNLOAD_CSV, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigateToGoalsEvent = ({
  eventName = HOME_EVENTS.TOP_NAV_NAVIGATION_EVENTS.NAVIGATED_TO_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// RABBIT NEW MIXPANEL EVENTS FOR GOALS

export const sendClickedOnCreateObjectiveEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_CREATE_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAddNewButton = ({
  eventName = GOAL_EVENTS.CLICKED_ON_ADD_NEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCheckedInKrEvent = ({ eventName = GOAL_EVENTS.CHECK_IN_KR, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedInitiativesInKrEvent = ({
  eventName = GOAL_EVENTS.ADDED_INITIATIVES_IN_KR,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnPraiseGoalsEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_PRAISE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnKebabMenuEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_KEBAB_MENU,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnCheckinEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_CHECK_IN_BUTTON,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCheckInRecordedEvent = ({ eventName = GOAL_EVENTS.CHECK_IN_RECORDED, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedShowParentObjectiveEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_SHOW_PARENT_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedRefreshEvent = ({ eventName = GOAL_EVENTS.CLICKED_REFRESH, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedExpandCollapseEvent = ({
  eventName = GOAL_EVENTS.CLICKED_ON_EXPAND_COLLAPSE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOKRDeletedEvent = ({ eventName = GOAL_EVENTS.GOAL_DELETED, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOKRUnarchivedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.GOAL_UNARCHIVED;
  sendEvent({ eventName, eventProperties });
};

export const sendMeshMavenClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.MESH_MAVEN_CLICKED;
  sendEvent({ eventName, eventProperties });
};

export const sendAIButtonClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.AI_BUTTON_CLICKED;
  sendEvent({ eventName, eventProperties });
};

export const sendConfigureMeshMavenClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.CONFIGURE_MESH_MAVEN_CLICKED;
  sendEvent({ eventName, eventProperties });
};

export const sendChangeDetailsClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.CHANGE_DETAILS_CLICKED;
  sendEvent({ eventName, eventProperties });
};

export const sendGoalEditedClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.GOAL_EDITED;
  sendEvent({ eventName, eventProperties });
};

export const sendViewFullHistoryClickedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.VIEW_FULL_HISTORY_CLICKED;
  sendEvent({ eventName, eventProperties });
};

export const sendSavedGoalsSettingsEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.SAVED_GOALS_SETTINGS;
  sendEvent({ eventName, eventProperties });
};

export const sendCreatedNewGoalsTemplateEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.CREATED_NEW_GOALS_TEMPLATE;
  sendEvent({ eventName, eventProperties });
};

export const sendAISuggestionUsedEvent = ({ eventProperties = {} } = {}) => {
  const eventName = GOAL_EVENTS.AI_SUGGESTION_USED;
  sendEvent({ eventName, eventProperties });
};

// Engagement events

export const sendShareExperienceClickedEvent = ({
  eventName = ENGAGEMENT_EVENTS.SHARE_EXPERIENCE_CLICKED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendShareExperiencePublishedEvent = ({
  eventName = ENGAGEMENT_EVENTS.SHARE_EXPERIENCE_PUBLISHED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedEngagementSurveyEvent = ({
  eventName = ENGAGEMENT_EVENTS.OPENED_ENGAGEMENT_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedBackEngagementSurveyEvent = ({
  eventName = ENGAGEMENT_EVENTS.CLICKED_BACK_ENGAGEMENT_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNextEngagementSurveyEvent = ({
  eventName = ENGAGEMENT_EVENTS.CLICKED_NEXT_ENGAGEMENT_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSubmittedSurveyFormEvent = ({
  eventName = ENGAGEMENT_EVENTS.SUBMITTED_SURVEY_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAnsweredSurveyQuestionEvent = ({
  eventName = ENGAGEMENT_EVENTS.ANSWERED_SURVEY_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnEngagementFilter = ({
  eventName = ENGAGEMENT_EVENTS.CLICKED_ON_ENGAGEMENT_FILTER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendStartedEngagementSurvey = ({
  eventName = ENGAGEMENT_EVENTS.STARTED_ENGAGEMENT_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendViewedEngagementSurvey = ({
  eventName = ENGAGEMENT_EVENTS.VIEWED_SUBMITTED_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSelectedSurvey = ({ eventName = ENGAGEMENT_EVENTS.SELECTED_SURVEY, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendScrolledDriverBadges = ({
  eventName = ENGAGEMENT_EVENTS.SCROLLED_DRIVER_BADGES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// Insights events

export const sendClickedMaxProgressOfGoalsEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_MAX_PROGRESS_OF_GOALS,
  eventProperties = { source: 'goals' },
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedMinProgressOfGoalsEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_MIN_PROGRESS_OF_GOALS,
  eventProperties = { source: 'goals' },
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedInsightsGraphOfGoalsEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_INSIGHTS_GRAPH_OF_GOALS,
  eventProperties = { source: 'goals' },
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedMaxGrowthOfCFEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_MAX_GROWTH_OF_CF,
  eventProperties = { source: 'feedbacks' },
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedMinGrowthOfCFEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_MIN_GROWTH_OF_CF,
  eventProperties = { source: 'feedbacks' },
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSelectCohortEvent = ({ eventName = INSIGHT_EVENTS.SELECTED_COHORT, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCreateNewCohortEvent = ({
  eventName = INSIGHT_EVENTS.CREATE_NEW_COHORT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSelectedGroupByEvent = ({
  eventName = INSIGHT_EVENTS.SELECTED_GROUP_BY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendDownloadCSVEvent = ({ eventName = INSIGHT_EVENTS.DOWNLOAD_CSV, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedTimelineEvent = ({
  eventName = INSIGHT_EVENTS.CHANGED_TIMELINE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSortedColumnsEvent = ({ eventName = INSIGHT_EVENTS.SORTED_COLUMNS, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedStatusInsightsEvent = ({
  eventName = INSIGHT_EVENTS.OPENED_STATUS_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedCalibrationInsightsEvent = ({
  eventName = INSIGHT_EVENTS.OPENED_CALIBRATION_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedCalibrationEvent = ({
  eventName = INSIGHT_EVENTS.COMPLETED_CALIBRATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedSurveyEvent = ({ eventName = INSIGHT_EVENTS.CHANGED_SURVEY, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedSplitByEvent = ({ eventName = INSIGHT_EVENTS.CHANGED_SPLIT_BY, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendDriverClickedEvent = ({ eventName = INSIGHT_EVENTS.DRIVER_CLICKED, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendExpandedChartEvent = ({ eventName = INSIGHT_EVENTS.EXPANDED_CHART, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAgGridFilterEvent = ({ eventName = INSIGHT_EVENTS.AG_GRID_FILTER, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAgGridSortEvent = ({ eventName = INSIGHT_EVENTS.AG_GRID_SORT, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedColumnsEvent = ({
  eventName = INSIGHT_EVENTS.CLICKED_ON_CHANGE_COLUMNS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// Reviews events

export const sendOpenedNominationPanelEvent = ({
  eventName = REVIEW_EVENTS.OPENED_NOMINATION_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendSearchedNominationsEvent = ({
  eventName = REVIEW_EVENTS.SEARCHED_NOMINATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
// export const sendClickedNominationBoxEvent = ({
//   eventName = REVIEW_EVENTS.CLICKED_NOMINATIONS_BOX,
//   eventProperties = {}
// } = {}) => {
//   sendEvent({ eventName, eventProperties });
// };
export const sendSelectedNominationEvent = ({
  eventName = REVIEW_EVENTS.SELECTED_NOMINATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendRemovedNominationEvent = ({
  eventName = REVIEW_EVENTS.REMOVED_NOMINATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedAddMoreEvent = ({ eventName = REVIEW_EVENTS.CLICKED_ADD_MORE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClosedNominationPanelEvent = ({
  eventName = REVIEW_EVENTS.CLOSED_NOMINATIONS_PANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedNominateEvent = ({ eventName = REVIEW_EVENTS.CLICKED_NOMINATE, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedNextPendingReviewsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_PENDING_REVIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedPreviousPendingReviewsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PREVIOUS_PENDING_REVIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAcknowledgedReviewFormEvent = ({
  eventName = REVIEW_EVENTS.ACKNOWLEDGED_REVIEW_FORM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedAccordionEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_ACCORDION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedReviewGuideEvent = ({
  eventName = REVIEW_EVENTS.OPENED_REVIEW_GUIDE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenCompetencyFromAccordionEvent = ({
  eventName = REVIEW_EVENTS.OPEN_COMPETENCY_FROM_ACCORDION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendOpenPastOneOnOneFromAccordionEvent = ({
  eventName = REVIEW_EVENTS.OPEN_PAST_ONE_ON_ONE_FROM_ACCORDION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedNextAccordionEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_ACCORDION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedPreviousAccordionEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PREVIOUS_ACCORDION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNextTeamStatusEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_TEAM_STATUS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedPreviousTeamStatusEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PREVIOUS_TEAM_STATUS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedNextCompletedReviewsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_NEXT_COMPLETED_REVIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendClickedPreviousCompletedReviewsEvent = ({
  eventName = REVIEW_EVENTS.CLICKED_PREVIOUS_COMPLETED_REVIEWS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
export const sendEmailPDFReportEvent = ({ eventName = REVIEW_EVENTS.EMAIL_PDF_REPORT, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

// LEVELUP events

export const sendAddedOnboardingToOneOnOneEvent = ({
  eventName = LEVELUP_EVENTS.ADDED_ONBOARDING_TO_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSetupLevelUpRoleEvent = ({
  eventName = LEVELUP_EVENTS.SETUP_LEVELUP_ROLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedTargetQuarterEvent = ({
  eventName = LEVELUP_EVENTS.ADDED_TARGET_QUARTER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedTargetQuarterEvent = ({
  eventName = LEVELUP_EVENTS.CHANGED_TARGET_QUARTER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendChangedLevelUpProgressEvent = ({
  eventName = LEVELUP_EVENTS.CHANGED_LEVELUP_PROGRESS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnMeshRecommendsEvent = ({
  eventName = LEVELUP_EVENTS.CLICKED_ON_MESH_RECOMMENDS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOpenedLevelUpSidePanelEvent = ({
  eventName = LEVELUP_EVENTS.OPENED_LEVELUP_SIDEPANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedLevelUpSidePanelEvent = ({
  eventName = LEVELUP_EVENTS.CLICKED_LEVELUP_SIDEPANEL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedToOneOnOneAgendaEvent = ({
  eventName = LEVELUP_EVENTS.ADDED_TO_ONE_ON_ONE_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
// export const sendCheckedInLevelUpEvent = ({
//   eventName = LEVELUP_EVENTS.CHECKED_IN_LEVELUP,
//   eventProperties = {}
// } = {}) => {
//   sendEvent({ eventName, eventProperties });
// };

export const sendClickedTopViewFilterEvent = ({
  eventName = LEVELUP_EVENTS.CLICKED_TOP_VIEW_FILTER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedLevelupCommentEvent = ({
  eventName = LEVELUP_EVENTS.ADDED_LEVELUP_COMMENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompletedActionItemEvent = ({
  eventName = LEVELUP_EVENTS.COMPLETED_ACTION_ITEM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAddedActionItemEvent = ({
  eventName = LEVELUP_EVENTS.ADDED_ACTION_ITEM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnLevelUpTabEvent = ({
  eventName = LEVELUP_EVENTS.CLICKED_ON_LEVELUP_TAB,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLevelUpViewChangedEvent = ({
  eventName = LEVELUP_EVENTS.LEVEL_UP_VIEW_CHANGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLevelUpExpandedEvent = ({
  eventName = LEVELUP_EVENTS.LEVEL_UP_EXPANDED_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLevelUpClickedOnDiscussNextOneOnOneEvent = ({
  eventName = LEVELUP_EVENTS.LEVEL_UP_CLICKED_ON_DISCUSS_NEXT_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// ------------------------------ old events to be removed...

export const sendTaskEvent = sendEvent2();

export const sendGoalEvent = sendEvent2();

export const sendOneOnOneEvent = sendEvent2();

export const sendReviewEvent = sendEvent2();

export const sendEmailCaptureEvents = sendEvent2();

export const sendEmailValidationEvents = sendEvent2();

export const sendDeptSelectionEvents = sendEvent2();

export const sendTeamSelectionEvents = sendEvent2();

export const sendTeamInviteEvents = sendEvent2();

// TODO: to be removed as complete onboarding flow is being revamped
// export const sendOnboardingEvents = sendEvent2({
//   flow: 'Onboarding',
//   pageName: 'Tour',
//   allEventsObject: ONBOARDING_EVENTS
// });

export const sendPostEvent = sendEvent2();

export const sendSearchBarEvents = sendEvent2();

export const sendTeamHubEvents = sendEvent2();

export const sendContinuousFeedbackEvents = sendEvent2();

export const sendReviewEvents = sendEvent2();

// export const sendNotificationEvents = sendEvent2({
//   actionType1: 'Notification'
// });

export const sendGoalAnalyticsEvents = sendEvent2();

// Settings Events

export const sendMyPodsCreateAPod = ({
  eventName = SETTINGS_EVENTS.MY_PODS_CREATE_A_POD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOrgDetailsUpdatedOrganisationDetails = ({
  eventName = SETTINGS_EVENTS.ORG_DETAILS_UPDATED_ORGANISATION_DETAILS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsAddedEmployee = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_ADDED_EMPLOYEE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsBulkUpload = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_BULK_UPLOAD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsDeletedAnEmployee = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_DELETED_AN_EMPLOYEE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsOpenedEmployeeDetails = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_OPENED_EMPLOYEE_DETAILS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsUpdatedEmployeeDetails = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_UPDATED_EMPLOYEE_DETAILS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsDownloadCSV = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_DOWNLOAD_CSV,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEmployeeDetailsSearchedEmployee = ({
  eventName = SETTINGS_EVENTS.EMPLOYEE_DETAILS_SEARCHED_EMPLOYEE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompetenciesAddedCompetency = ({
  eventName = SETTINGS_EVENTS.COMPETENCIES_ADDED_COMPETENCY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompetenciesChangedSetting = ({
  eventName = SETTINGS_EVENTS.COMPETENCIES_CHANGED_SETTING,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCompetenciesUpdatedDescription = ({
  eventName = SETTINGS_EVENTS.COMPETENCIES_UPDATED_DESCRIPTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendFunctionAndGradeClickedOnFunction = ({
  eventName = SETTINGS_EVENTS.FUNCTION_AND_GRADE_CLICKED_ON_FUNCTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAccessControlClickedOnCreateAccess = ({
  eventName = SETTINGS_EVENTS.ACCESS_CONTROL_CLICKED_ON_CREATE_ACCESS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAccessControlEditEmployees = ({
  eventName = SETTINGS_EVENTS.ACCESS_CONTROL_EDIT_EMPLOYEES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendAccessControlSavedCustomAccess = ({
  eventName = SETTINGS_EVENTS.ACCESS_CONTROL_SAVED_CUSTOM_ACCESS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendModulePreferencesChangedModulePreferences = ({
  eventName = SETTINGS_EVENTS.MODULE_PREFERENCES_CHANGED_MODULE_PREFERENCES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotificationsChangedNotificationPreferences = ({
  eventName = SETTINGS_EVENTS.NOTIFICATIONS_CHANGED_NOTIFICATION_PREFERENCES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotificationsSetDefaultPreferences = ({
  eventName = SETTINGS_EVENTS.NOTIFICATIONS_SET_DEFAULT_PREFERENCES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNotificationsResetDefaultPreferences = ({
  eventName = SETTINGS_EVENTS.NOTIFICATIONS_RESET_DEFAULT_PREFERENCES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesClonedObjective = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_CLONED_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesRenamedObjective = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_RENAMED_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesReplaceObjective = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_REPLACE_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesDeletedObjective = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_DELETED_OBJECTIVE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesClickedAllObjectivesInSettings = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_CLICKED_ALL_OBJECTIVES_IN_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesClickedActiveObjectivesInSettings = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_CLICKED_ACTIVE_OBJECTIVES_IN_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesUpdatedFrequencyOfGoals = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_UPDATED_FREQUENCY_OF_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesUpdatedStartMonthOfGoals = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_UPDATED_START_MONTH_OF_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendObjectivesUpdatedDefaultVisibilityOfGoals = ({
  eventName = SETTINGS_EVENTS.OBJECTIVES_UPDATED_DEFAULT_VISIBILITY_OF_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeQuestionLibraryAddedQuestion = ({
  eventName = SETTINGS_EVENTS.ONEONONE_QUESTION_LIBRARY_ADDED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeQuestionLibraryDuplicatedQuestion = ({
  eventName = SETTINGS_EVENTS.ONEONONE_QUESTION_LIBRARY_DUPLICATED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeQuestionLibraryArchivedQuestion = ({
  eventName = SETTINGS_EVENTS.ONEONONE_QUESTION_LIBRARY_ARCHIVED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeQuestionLibraryCopiedQuestionLink = ({
  eventName = SETTINGS_EVENTS.ONEONONE_QUESTION_LIBRARY_COPIED_QUESTION_LINK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeTemplatesAddedTemplate = ({
  eventName = SETTINGS_EVENTS.ONEONONE_TEMPLATES_ADDED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeTemplatesDuplicatedTemplate = ({
  eventName = SETTINGS_EVENTS.ONEONONE_TEMPLATES_DUPLICATED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeTemplatesArchivedTemplate = ({
  eventName = SETTINGS_EVENTS.ONEONONE_TEMPLATES_ARCHIVED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeSettingsModifiedFrequency = ({
  eventName = SETTINGS_EVENTS.ONEONONE_SETTINGS_MODIFIED_FREQUENCY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendOneononeSettingsModifiedTemplate = ({
  eventName = SETTINGS_EVENTS.ONEONONE_SETTINGS_MODIFIED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryAddedQuestion = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_ADDED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryDuplicatedQuestion = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_DUPLICATED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryArchivedQuestion = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_ARCHIVED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryCopiedQuestionLink = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_COPIED_QUESTION_LINK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibrarySearchedAQuestion = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_SEARCHED_A_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryClickedOnSampleQuestions = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_CLICKED_ON_SAMPLE_QUESTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibraryClickedOnArchivedQuestions = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_CLICKED_ON_ARCHIVED_QUESTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsQuestionLibrarySavedQuestion = ({
  eventName = SETTINGS_EVENTS.REVIEWS_QUESTION_LIBRARY_SAVED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateClickedOnAddTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_CLICKED_ON_ADD_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateCreatedANewTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_CREATED_A_NEW_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateDuplicatedTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_DUPLICATED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateArchivedTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_ARCHIVED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateOpenedTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_OPENED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateClickedModifyTemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_CLICKED_MODIFY_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateClickedPreview = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_CLICKED_PREVIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsTemplateSavedATemplate = ({
  eventName = SETTINGS_EVENTS.REVIEWS_TEMPLATE_SAVED_A_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsCycleClickedOnCreateNew = ({
  eventName = SETTINGS_EVENTS.REVIEWS_CYCLE_CLICKED_ON_CREATE_NEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsCycleOpenedReviewSettings = ({
  eventName = SETTINGS_EVENTS.REVIEWS_CYCLE_OPENED_REVIEW_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsCycleClickedOnNextReviewCycleSettings = ({
  eventName = SETTINGS_EVENTS.REVIEWS_CYCLE_CLICKED_ON_NEXT_REVIEW_CYCLE_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsCycleClickedOnBackReviewCycleSettings = ({
  eventName = SETTINGS_EVENTS.REVIEWS_CYCLE_CLICKED_ON_BACK_REVIEW_CYCLE_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewsCycleCreatedAReviewCycleInstance = ({
  eventName = SETTINGS_EVENTS.REVIEWS_CYCLE_CREATED_A_REVIEW_CYCLE_INSTANCE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCalibrationSettingsChangedReviewCycleDate = ({
  eventName = SETTINGS_EVENTS.CALIBRATION_SETTINGS_CHANGED_REVIEW_CYCLE_DATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCalibrationSettingsChangedScoreType = ({
  eventName = SETTINGS_EVENTS.CALIBRATION_SETTINGS_CHANGED_SCORE_TYPE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendCalibrationSettingsSavedCalibrationGridChanges = ({
  eventName = SETTINGS_EVENTS.CALIBRATION_SETTINGS_SAVED_CALIBRATION_GRID_CHANGES,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementDriversAddedNewDriver = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_DRIVERS_ADDED_NEW_DRIVER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementDriversUpdatedEngagementDriver = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_DRIVERS_UPDATED_ENGAGEMENT_DRIVER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementDriversDeletedEngagementDriver = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_DRIVERS_DELETED_ENGAGEMENT_DRIVER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsAddedQuestion = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_ADDED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsDuplicatedQuestion = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_DUPLICATED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsArchivedQuestion = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_ARCHIVED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsCopiedQuestionLink = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_COPIED_QUESTION_LINK,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsSearchedAQuestion = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_SEARCHED_A_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsClickedOnSampleQuestions = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_CLICKED_ON_SAMPLE_QUESTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsClickedOnArchivedQuestions = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_CLICKED_ON_ARCHIVED_QUESTIONS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementQuestionsSavedQuestions = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_QUESTIONS_SAVED_QUESTION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateClickedOnAddTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_CLICKED_ON_ADD_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateCreatedANewTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_CREATED_A_NEW_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateDuplicatedTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_DUPLICATED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateArchivedTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_ARCHIVED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateOpenedTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_OPENED_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateClickedModifyTemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_CLICKED_MODIFY_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateClickedPreview = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_CLICKED_PREVIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementTemplateSavedATemplate = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_TEMPLATE_SAVED_A_TEMPLATE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementSurveysClickedOnCreateNew = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_SURVEYS_CLICKED_ON_CREATE_NEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementSurveysOpenedSurveySettings = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_SURVEYS_OPENED_SURVEY_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementSurveysClickedOnNextSurveySettings = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_SURVEYS_CLICKED_ON_NEXT_SURVEY_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementSurveysClickedOnBackSurveySettings = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_SURVEYS_CLICKED_ON_BACK_SURVEY_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendEngagementSurveysClickedOnCreateSurvey = ({
  eventName = SETTINGS_EVENTS.ENGAGEMENT_SURVEYS_CLICKED_ON_CREATE_SURVEY,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendInitiativeTagsAddedNewTaskTag = ({
  eventName = SETTINGS_EVENTS.INITIATIVE_TAGS_ADDED_NEW_TASK_TAG,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSlackClickedOnAdd = ({
  eventName = SETTINGS_EVENTS.SLACK_CLICKED_ON_ADD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSlackIntegrationSuccessful = ({
  eventName = SETTINGS_EVENTS.SLACK_INTEGRATION_SUCCESSFUL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendHelpOpenedKnowledgeHub = ({
  eventName = SETTINGS_EVENTS.HELP_OPENED_KNOWLEDGE_HUB,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendHelpReportABug = ({ eventName = SETTINGS_EVENTS.HELP_REPORT_A_BUG, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendMeshRecommendsClickedEvent = ({
  eventName = MESH_RECOMMENDATIONS_EVENTS.CLICKED_ON_MESH_RECOMMENDS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSnoozedMeshRecommendsClickedEvent = ({
  eventName = MESH_RECOMMENDATIONS_EVENTS.SNOOZED_MESH_RECOMMENDS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
// 1:1 RABBIT LANDING PAGE

export const sendClickedOnOneOnOneFilter = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON__ONE_ON_ONE_FILTER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneKebabButton = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_MY_ONE_ON_ONE_KEBAB_BUTTON,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedAddNewOnOneOnOne = ({
  eventName = ONE_ON_ONE_EVENTS.CLICKED_ON_CREATE_NEW_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedAddedOnOneOnOne = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_NEW_ONE_ON_ONE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOneonOneInstancePageOpened = ({
  eventName = ONE_ON_ONE_EVENTS.OPENED_ONE_ON_ONE_INSTANCE_PAGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneQuickHelp = ({
  eventName = ONE_ON_ONE_EVENTS.QUICK_HELP_CLICKED,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

// 1:1 RABBIT SETTINGS PAGE

export const sendClickedOnOneOnOneScoreSettings = ({
  eventName = ONE_ON_ONE_RABBIT_SETTINGS_PAGE.CLICKED_ON_ONE_ON_ONE_SCORE_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneAddedAdminAgendaPoints = ({
  eventName = ONE_ON_ONE_RABBIT_SETTINGS_PAGE.ADDED_ADMIN_AGENDA_POINTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneLifecycleEvent = ({
  eventName = ONE_ON_ONE_RABBIT_SETTINGS_PAGE.CREATED_ONE_ON_ONE_LIFECYCLE_EVENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneCalenderIntegration = ({
  eventName = ONE_ON_ONE_RABBIT_SETTINGS_PAGE.CLICKED_ON_CALENDER_INTEGRATION,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnOneOnOneAddAgendaFromLibrary = ({
  eventName = ONE_ON_ONE_EVENTS.ADDED_ONE_ON_ONE_AGENDA,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendGivenSatisfactionScore = ({
  eventName = ONE_ON_ONE_EVENTS.PROVIDED_SATISFACTION_SCORE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSavedOneOnOneSettings = ({
  eventName = ONE_ON_ONE_EVENTS.SAVED_ONE_ON_ONE_SETTINGS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendSyncOneOnOneCalendarEvent = ({
  eventName = ONE_ON_ONE_EVENTS.SYNC_ONE_ON_ONE_CALENDAR_EVENT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToReportsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_REPORTS,
  eventProperties = {},
} = {}) => {
  console.log('Event called  reports');

  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToGoalsReportsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_GOALS_REPORTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToReviewReportsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_REVIEW_REPORTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToOneOnONeReportsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_ONE_ON_ONE_REPORTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToGoalsInsightsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_GOALS_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToCompetenciesInsightsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_COMPETENCIES_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToOneOnOneInsightsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_ONE_ON_ONE_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToReviewsInsightsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_REVIEWS_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNavigatedToEngagementInsightsEvent = ({
  eventName = VISIER_ANALYTICS_EVENTS.NAVIGATED_TO_ENGAGEMENT_INSIGHTS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNewNavBannerEvent = ({
  eventName = NEW_NAV_EVENTS.CLICKED_NEW_NAV_BANNER,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendNewUXExperiencePageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedNewNavPreviewEvent = ({
  eventName = NEW_NAV_EVENTS.CLICKED_PREVIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedLaunchForAllEvent = ({
  eventName = NEW_NAV_EVENTS.CLICKED_LAUNCH_FOR_ALL,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendLaunchedNewNavForOrgEvent = ({
  eventName = NEW_NAV_EVENTS.LAUNCHED_NEW_NAV_FOR_ORG,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnBackToRabbitEvent = ({
  eventName = NEW_NAV_EVENTS.CLICKED_ON_BACK_TO_RABBIT,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendMeBulkCheckInPageViewEvent = ({ eventName = NEW_NAV_EVENTS.PAGE_VIEW, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Me-goals-bulkcheckin' } });
};

export const sendDirectTeamBulkCheckInPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Direct team-goals-bulkcheckin' } });
};

export const sendSkipTeamBulkCheckInPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Skip team-goals-bulkcheckin' } });
};

export const sendCompanyBulkCheckInPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Company-goals-bulkcheckin' } });
};

export const sendClickedOnSearch = ({ eventName = NEW_NAV_EVENTS.CLICKED_ON_SEARCH, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnHome = ({ eventName = NEW_NAV_EVENTS.CLICKED_ON_HOME, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnMe = ({ eventName = NEW_NAV_EVENTS.CLICKED_ON_ME, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnTeams = ({ eventName = NEW_NAV_EVENTS.HOVERED_ON_TEAMS, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnDirectTeam = ({
  eventName = NEW_NAV_EVENTS.CLICKED_ON_DIRECT_TEAM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnSkipTeam = ({
  eventName = NEW_NAV_EVENTS.CLICKED_ON_SKIP_TEAM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnCompany = ({ eventName = NEW_NAV_EVENTS.CLICKED_ON_COMPANY, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnQuickAdd = ({
  eventName = NEW_NAV_EVENTS.HOVERED_ON_QUICK_ADD,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnProfileIcon = ({
  eventName = NEW_NAV_EVENTS.HOVERED_ON_PROFILE_ICON,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendClickedOnAskMaven = ({
  eventName = NEW_NAV_EVENTS.CLICKED_ON_ASK_MAVEN,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendReviewSummaryPageViewEvent = ({ eventName = NEW_NAV_EVENTS.PAGE_VIEW, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'ReviewSummary-Viewed' } });
};

export const sendReviewFormPageViewEvent = ({ eventName = NEW_NAV_EVENTS.PAGE_VIEW, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'ReviewForm-Opened' } });
};
export const sendClickedOnSaveBulkCheckInME = ({
  eventName = NEW_NAV_EVENTS.SAVE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-savebulkcheckin' } });
};

export const sendClickedOnSaveBulkCheckInDirectTeam = ({
  eventName = NEW_NAV_EVENTS.SAVE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-savebulkcheckin' } });
};

export const sendClickedOnSaveBulkCheckInSkipTeam = ({
  eventName = NEW_NAV_EVENTS.SAVE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-savebulkcheckin' } });
};

export const sendClickedOnSaveBulkCheckInCompany = ({
  eventName = NEW_NAV_EVENTS.SAVE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-savebulkcheckin' } });
};

export const sendClickedOnCancelBulkCheckInMe = ({
  eventName = NEW_NAV_EVENTS.CANCEL_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-cancelbulkcheckin' } });
};

export const sendClickedOnCancelBulkCheckInDirectTeam = ({
  eventName = NEW_NAV_EVENTS.CANCEL_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-cancelbulkcheckin' } });
};

export const sendClickedOnCancelBulkCheckInSkipTeam = ({
  eventName = NEW_NAV_EVENTS.CANCEL_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-cancelbulkcheckin' } });
};

export const sendClickedOnCancelBulkCheckInCompany = ({
  eventName = NEW_NAV_EVENTS.CANCEL_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-cancelbulkcheckin' } });
};

export const sendChangedStatusBulkCheckInMe = ({
  eventName = NEW_NAV_EVENTS.CHANGED_STATUS_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-statusbulkcheckin' } });
};

export const sendChangedStatusBulkCheckInDirectTeam = ({
  eventName = NEW_NAV_EVENTS.CHANGED_STATUS_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-statusbulkcheckin' } });
};

export const sendChangedStatusBulkCheckInSkipTeam = ({
  eventName = NEW_NAV_EVENTS.CHANGED_STATUS_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-statusbulkcheckin' } });
};

export const sendChangedStatusBulkCheckInCompany = ({
  eventName = NEW_NAV_EVENTS.CHANGED_STATUS_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-statusbulkcheckin' } });
};

export const sendChangedAchievedValueBulkCheckInMe = ({
  eventName = NEW_NAV_EVENTS.CHANGED_ACHIEVED_VALUE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-achievedvaluebulkcheckin' } });
};

export const sendChangedAchievedValueBulkCheckInDirectTeam = ({
  eventName = NEW_NAV_EVENTS.CHANGED_ACHIEVED_VALUE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({
    eventName,
    eventProperties: { ...eventProperties, source: 'Direct team-goals-achievedvaluebulkcheckin' },
  });
};

export const sendChangedAchievedValueBulkCheckInSkipTeam = ({
  eventName = NEW_NAV_EVENTS.CHANGED_ACHIEVED_VALUE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-achievedvaluebulkcheckin' } });
};

export const sendChangedAchievedValueBulkCheckInCompany = ({
  eventName = NEW_NAV_EVENTS.CHANGED_ACHIEVED_VALUE_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-achievedvaluebulkcheckin' } });
};

export const sendAddedCommentBulkCheckInMe = ({
  eventName = NEW_NAV_EVENTS.ADDED_COMMENT_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-commentedbulkcheckin' } });
};

export const sendAddedCommentBulkCheckInDirectTeam = ({
  eventName = NEW_NAV_EVENTS.ADDED_COMMENT_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-commentedbulkcheckin' } });
};

export const sendAddedCommentBulkCheckInSkipTeam = ({
  eventName = NEW_NAV_EVENTS.ADDED_COMMENT_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-commentedbulkcheckin' } });
};

export const sendAddedCommentBulkCheckInCompany = ({
  eventName = NEW_NAV_EVENTS.ADDED_COMMENT_BULK_CHECKIN_GOALS,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-commentedbulkcheckin' } });
};

export const sendMeBulkUploadPageViewEvent = ({ eventName = NEW_NAV_EVENTS.PAGE_VIEW, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Me-goals-upload' } });
};

export const sendDirectTeamBulkUploadPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Direct team-goals-upload' } });
};

export const sendSkipTeamBulkUploadPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Skip team-goals-upload' } });
};

export const sendCompanyBulkUploadPageViewEvent = ({
  eventName = NEW_NAV_EVENTS.PAGE_VIEW,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'Company-goals-upload' } });
};

export const sendBulkUploadTimeLineChangeEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_TIMELINE_CHANGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-time period filter' } });
};

export const sendBulkUploadTimeLineChangeEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_TIMELINE_CHANGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-time period filter' } });
};

export const sendBulkUploadTimeLineChangeEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_TIMELINE_CHANGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-time period filter' } });
};

export const sendBulkUploadTimeLineChangeEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_TIMELINE_CHANGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-time period filter' } });
};

export const sendBulkUploadFileAttachedEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_ATTACHED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-attachgoalfile' } });
};

export const sendBulkUploadFileAttachedEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_ATTACHED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-attachgoalfile' } });
};

export const sendBulkUploadFileAttachedEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_ATTACHED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-attachgoalfile' } });
};

export const sendBulkUploadFileAttachedEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_ATTACHED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-attachgoalfile' } });
};

export const sendBulkUploadFileUploadedEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_UPLOADED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-Upload Goal' } });
};

export const sendBulkUploadFileUploadedEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_UPLOADED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-Upload Goal' } });
};

export const sendBulkUploadFileUploadedEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_UPLOADED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-Upload Goal' } });
};

export const sendBulkUploadFileUploadedEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_UPLOADED_FILE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-Upload Goal' } });
};

export const sendBulkUploadDownloadQuickGoalSampleFileEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_QUICK_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-downloadquicksample' } });
};

export const sendBulkUploadDownloadQuickGoalSampleFileEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_QUICK_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-downloadquicksample' } });
};

export const sendBulkUploadDownloadQuickGoalSampleFileEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_QUICK_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-downloadquicksample' } });
};

export const sendBulkUploadDownloadQuickGoalSampleFileEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_QUICK_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-downloadquicksample' } });
};

export const sendBulkUploadDownloadExtendedGoalSampleFileEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_EXTENDED_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-downloadextsample' } });
};

export const sendBulkUploadDownloadExtendedGoalSampleFileEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_EXTENDED_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-downloadextsample' } });
};

export const sendBulkUploadDownloadExtendedGoalSampleFileEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_EXTENDED_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-downloadextsample' } });
};

export const sendBulkUploadDownloadExtendedGoalSampleFileEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_DOWNLOAD_GOAL_EXTENDED_SAMPLE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-downloadextsample' } });
};

export const sendBulkUploadViewGuideEventMe = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_VIEW_GUIDE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Me-goals-viewgoaluploadguide' } });
};

export const sendBulkUploadViewGuideEventDirectTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_VIEW_GUIDE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Direct team-goals-viewgoaluploadguide' } });
};

export const sendBulkUploadViewGuideEventSkipTeam = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_VIEW_GUIDE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Skip team-goals-viewgoaluploadguide' } });
};

export const sendBulkUploadViewGuideEventCompany = ({
  eventName = NEW_NAV_EVENTS.BULK_UPLOAD_VIEW_GUIDE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, source: 'Company-goals-viewgoaluploadguide' } });
};
export const sendClickedOnColdStartNudge = ({
  eventName = NEW_NAV_EVENTS.CLICKED_ON_COLD_START_NUDGE,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};

export const sendProfilePageViewEvent = ({ eventName = NEW_NAV_EVENTS.PAGE_VIEW, eventProperties = {} } = {}) => {
  sendEvent({ eventName, eventProperties: { ...eventProperties, page: 'UserProfile' } });
};

export const sendCreatedCustomTeamEvent = ({
  eventName = NEW_NAV_EVENTS.CREATED_A_CUSTOM_TEAM,
  eventProperties = {},
} = {}) => {
  sendEvent({ eventName, eventProperties });
};
